
import { mapGetters } from 'vuex'

import Currency from '~/mixins/Currency.js'

export default {
  mixins: [Currency],

  computed: {
    ...mapGetters('cart', ['cart', 'discounts', 'priceTotal', 'totalTax']),

    isShippingIncluded() {
      return !!this.cart?.shipping?.grossPrice > 0
    },
  },
}
